// TASK : This will be update once API is ready, for now mocking the hardcoded response.
export const getLoyaltyOrderItemPoints = (errorMapping, payload) => {
  // These logs are to avoid linting error for now later they will be used.
  console.log(errorMapping);
  console.log(payload);
  // TASK : This reqObject will get modified based on API needs, for now just keeping as mentioned in the jira ticket.
  // let reqObject = {
  //   mprId: 1234123,
  //   items: [
  //     {
  //       itemId: '2102011_10#2',
  //       variantNumber: 55334,
  //       quantity: 1,
  //       price: 100.0,
  //     },
  //   ],
  // };

  // TASK : Here Add/update executeStatefulGraphQLQuery call and return/handle response once API is ready
  // Note : Refer executeStatefulGraphQLQuery in AddedToBag.js at line no 972 for implementation.

  return {
    items: [
      {
        itemId: '3046904_1128',
        capturedPartNumber: '1124756',
        rewardPoints: 1,
      },
      {
        itemId: '3033678_3208',
        capturedPartNumber: '1124756',
        rewardPoints: 2,
      },
      {
        itemId: '3046642_1128',
        capturedPartNumber: '1124756',
        rewardPoints: 3,
      },
      {
        itemId: '3046640-32DC',
        capturedPartNumber: '1124756',
        rewardPoints: 4,
      },
    ],
    pointsAwarded: [
      {
        points: 0.0,
      },
    ],
  };
};

export default {
  getLoyaltyOrderItemPoints,
};
